// @flow
export const MAP_VIEW: 'm' = 'm';
export const LIST_VIEW: 'l' = 'l';
